import { i18n } from "@dehub/theme";

import mnAuth from "./locales/mn/auth.json";
import koAuth from "./locales/ko/auth.json";
import enAuth from "./locales/en/auth.json";
import zhAuth from "./locales/zh/auth.json";

import mnNotif from "./locales/mn/notifications.json";
import koNotif from "./locales/ko/notifications.json";
import enNotif from "./locales/en/notifications.json";
import zhNotif from "./locales/zh/notifications.json";

import mnLayout from "./locales/mn/layout.json";
import koLayout from "./locales/ko/layout.json";
import enLayout from "./locales/en/layout.json";
import zhLayout from "./locales/zh/layout.json";

import mnCommon from "./locales/mn/common.json";
import koCommon from "./locales/ko/common.json";
import enCommon from "./locales/en/common.json";
import zhCommon from "./locales/zh/common.json";

import mnProfileForm from "./locales/mn/profileForm.json";
import koProfileForm from "./locales/ko/profileForm.json";
import enProfileForm from "./locales/en/profileForm.json";
import zhProfileForm from "./locales/zh/profileForm.json";

import mnDashboard from "./locales/mn/dashboard.json";
import koDashboard from "./locales/ko/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import zhDashboard from "./locales/zh/dashboard.json";

import mnPrivacy from "./locales/mn/privacy.json";
import koPrivacy from "./locales/ko/privacy.json";
import enPrivacy from "./locales/en/privacy.json";
import zhPrivacy from "./locales/zh/privacy.json";

i18n.addResourceBundle("mn", "auth", mnAuth, true, true);
i18n.addResourceBundle("ko", "auth", koAuth, true, true);
i18n.addResourceBundle("en", "auth", enAuth, true, true);
i18n.addResourceBundle("zh", "auth", zhAuth, true, true);

i18n.addResourceBundle("mn", "notifications", mnNotif, true, true);
i18n.addResourceBundle("ko", "notifications", koNotif, true, true);
i18n.addResourceBundle("en", "notifications", enNotif, true, true);
i18n.addResourceBundle("zh", "notifications", zhNotif, true, true);

i18n.addResourceBundle("mn", "layout", mnLayout, true, true);
i18n.addResourceBundle("ko", "layout", koLayout, true, true);
i18n.addResourceBundle("en", "layout", enLayout, true, true);
i18n.addResourceBundle("zh", "layout", zhLayout, true, true);

i18n.addResourceBundle("mn", "common", mnCommon, true, true);
i18n.addResourceBundle("ko", "common", koCommon, true, true);
i18n.addResourceBundle("en", "common", enCommon, true, true);
i18n.addResourceBundle("zh", "common", zhCommon, true, true);

i18n.addResourceBundle("mn", "profileForm", mnProfileForm, true, true);
i18n.addResourceBundle("ko", "profileForm", koProfileForm, true, true);
i18n.addResourceBundle("en", "profileForm", enProfileForm, true, true);
i18n.addResourceBundle("zh", "profileForm", zhProfileForm, true, true);

i18n.addResourceBundle("mn", "dashboard", mnDashboard, true, true);
i18n.addResourceBundle("ko", "dashboard", koDashboard, true, true);
i18n.addResourceBundle("en", "dashboard", enDashboard, true, true);
i18n.addResourceBundle("zh", "dashboard", zhDashboard, true, true);

i18n.addResourceBundle("mn", "privacy", mnPrivacy, true, true);
i18n.addResourceBundle("ko", "privacy", koPrivacy, true, true);
i18n.addResourceBundle("en", "privacy", enPrivacy, true, true);
i18n.addResourceBundle("zh", "privacy", zhPrivacy, true, true);
